<template>
  <div class="businessType">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('businessType.collapseTitle.businessTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <business-table @row-change="rowChange" ref="businessTable" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2" v-show="businessRowIdx || businessRowIdx == 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('businessType.collapseTitle.interOperTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <inter-oper-table ref="interOperTable" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <footer class="fixed-bottom-btnList">
      <el-button @click="save()" class="fixed-bottom-btn" type="primary">{{
        $t('businessType.btnList.save')
      }}</el-button>
    </footer>
  </div>
</template>

<script>
  import businessTable from './components/businessTable'; // 业务单据类型
  import interOperTable from './components/interOperTable'; // 计息操作类型（事件类型）
  import API from '@/api/capitalCenter/moneyDraw';
  export default {
    name: 'businessType',
    components: {
      businessTable,
      interOperTable,
    },
    data() {
      return {
        activeNames: ['1', '2'],
        businessRowIdx: null,
      };
    },
    computed: {},
    methods: {
      async save() {
        let res = await this.$refs.businessTable.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          let _res = await this.$refs.interOperTable.exportChildData();
          if (_res) {
            let item = params.list[this.businessRowIdx];
            params.list[this.businessRowIdx] = {
              ...item,
              ..._res,
            };
          }
          this.saveData(params);
        }
      },
      rowChange(val) {
        this.businessRowIdx = val.$rowIndex;
        this.$refs.interOperTable.getData(val.row.orderCode);
      },
      async saveData(params) {
        this.loading.startLoading();
        // 保存提交
        let res = await this.$axios.post(API.SAVE_ORDERTYPE, params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.$refs.businessTable.getData();
            this.businessRowIdx = null;
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
    },
  };
</script>
